import axios from "axios";
import { base_URL } from '../config/config';

const API_BASE_URL = `${base_URL}/api`;

export const getContactUsList = async (params) => {
  try {
    const accessToken = localStorage.getItem("adminAccessToken");
    const response = await axios.get(`${API_BASE_URL}/contact`, {
      params,
      headers: {
        Authorization: `Bearer ${accessToken}`
      }
    });
    return response.data;
  } catch (error) {
    console.log('Error fetching contact us list', error);
    throw error;
  }
};
